import { NodeModel } from "../_model/NodeModel";
import { DecorationTanque } from "../tanque/decorationTanque";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";
import { SingletonInter } from "../_service/singletonInter";

class Tanque extends NodeModel {
    constructor(location = { x: 0, y: 0 }) {
        super("Tanque");

        this.type = new Types().Tanque;

        this.x = location.x;
        this.y = location.y;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 80;
        this.width = 100;
        this.tx = 0;
        this.Xw = 0;
        this.tanqueSelected = "tanque.png"
        this.title = SingletonInter.$t('tanque')
        this.srcImg = require("@/assets/Fluxogramas/tanque.png");
        this.expressionVisible = ""
        this.data = [new Properties({...this })];

        this.decorate = async function(callback) {
            this.decorator = new DecorationTanque();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Tanque()
            cloned.expressionVisible = this.expressionVisible
            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.readOnly = this.readOnly;
            cloned.tanqueSelected = this.tanqueSelected;
            cloned.expressionVisible = this.expressionVisible;
            cloned.title = this.title;
            cloned.decorator = null
            cloned.data = this.data.map(d => d.clone());

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.tanqueSelected = node.tanqueSelected
            this.title = node.title;
        }

        this.update = (nodeEdited) => {
            this.tanqueSelected = nodeEdited.tanqueSelected;
            this.expressionVisible = nodeEdited.expressionVisible;
            this.title = nodeEdited.title;
            this.decorator.update()
        }
    }
}

export { Tanque };